import React from 'react';
import EditScheduledMessagePage from './components/EditScheduledMessagePage';

function ScheduledMessageEdit() {
  return <EditScheduledMessagePage mode="user" />;
}

export default ScheduledMessageEdit;
